export type MailToastVariant = "success" | "error" | "info";

export type MailToastEntry = {
  id: string;
  message: string;
  variant: MailToastVariant;
};

let toasts: MailToastEntry[] = [];
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

function nextToastId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `toast-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function getMailToasts(): readonly MailToastEntry[] {
  return toasts;
}

export function subscribeMailToasts(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function dismissMailToast(id: string): void {
  const next = toasts.filter((entry) => entry.id !== id);
  if (next.length === toasts.length) return;
  toasts = next;
  emit();
}

export function showMailToast(
  message: string,
  variant: MailToastVariant = "info",
  durationMs = 4800
): void {
  const id = nextToastId();
  toasts = [...toasts, { id, message, variant }];
  emit();
  window.setTimeout(() => dismissMailToast(id), durationMs);
}
